class ProductFeaturesCarousel extends window.BAO.CustomElement {
  constructor () {
    super()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.initialiseCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.prev.element,
      'click',
      this.onNavClick.bind(this)
    )

    this.listeners.add(
      this.els.next.element,
      'click',
      this.onNavClick.bind(this)
    )
  }

  initialiseCarousel () {
    const carousel = new window.KeenSlider685(this.els.slides.element, {
      loop: false,
      mode: 'snap',
      rtl: false,
      slides: {
        perView: 1.1,
        spacing: 15
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 2.1,
            spacing: 20
          }
        },
        '(min-width: 1024px)': {
          slides: {
            perView: 2.9,
            spacing: 20
          }
        }
      }
    })

    this.els.slides.element.classList.add(
      'sec-ProductFeaturesCarousel_Slides-initialised'
    )

    carousel.on('slideChanged', () => {
      this.els.prev.element.disabled = carousel.track.details.rel === 0

      this.els.next.element.disabled =
        carousel.track.details.rel === carousel.track.details.maxIdx

      this.els.dot.elements.forEach((dot, index) => {
        dot.setAttribute('aria-current', carousel.track.details.rel === index)
      })
    })

    return carousel
  }

  onNavClick (event) {
    if (event.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

if (!customElements.get('product-features-carousel')) {
  customElements.define('product-features-carousel', ProductFeaturesCarousel)
}
